import React, {useEffect, useState} from "react"
import {IonContent, IonFooter, IonHeader, IonItem, IonModal, IonPage, IonToast, IonToolbar, Gesture, createGesture} from "@ionic/react"
import Search from "./Search"
import Contacts from "./Contacts"
import Load from "./Load"
import ProfileInfo from "./ProfileInfo"
import Game from "./Game"
import Trip from "./Trip"
import Money from "./Money"
import Docs from "./Docs"
import Nav from "./Nav"
import Onboard from "./Onboard"
import Toolbar from "./Toolbar"
import chevronRight from "../imgs/chevron-right.png";
import {Link, useHistory} from "react-router-dom";
import { checkOS } from "../components/OSCheck";
import {ApiService} from "../api/ApiService";
import {UserUtils} from "../utils/UserUtils";
import { userStore, UserState } from "../api/AuthService"
import { DriverProfile } from "../api/model/DriverProfile"
import { PushNotificationsService } from "../api/PushNotificationsService"
import { userInfo } from "os"
import { sidnavStore, SidenavState } from "../api/SidenavStore"
import { Capacitor } from "@capacitor/core"
import { AppUpdate } from "@capawesome/capacitor-app-update"
import { runStatus } from "../components/walkthrough/FirstSignIn"


const Home: React.FC = () => {
    const history = useHistory();

    const [isLookingForOrder, setIsLookingForOrder] = useState(false)
    const [noOrderFound, setNoOrderFound] = useState(false)
    const [orderPaidDate, setOrderPaidDate] = useState("")

    const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));
    const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
    const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));
    
    const ref = React.useRef<HTMLInputElement>(null)

    useEffect(() => {
        getAvailableAppVersion();
        gestureInit();
        console.log("os", checkOS());
        if (localStorage.getItem("pushNotificationPermission") === null) {
            console.log("register push", localStorage.getItem("pushNotificationPermission"));
            PushNotificationsService.registerAfterAppLogin(userStore.getState().user!.id)
        }
    }, [])

    const getAvailableAppVersion = async () => {
        try {
            const result = await AppUpdate.getAppUpdateInfo();
            if (Capacitor.getPlatform() === 'android') {
            console.log("code", result.availableVersionCode);
            } else {
            console.log("name", result.availableVersionName);
                
            }
        } catch (error) {
            console.log("Error getting version", error);
        }
    };

    const gestureInit = () => {
        const card = ref.current
        if (card) {
            const gesture = createGesture({
                el: card,
                gestureName: 'swipeMenu',
                onMove: (detail) => {
                    console.log("moving");
                },
                onEnd: (detail) => {
                    console.log("move ended");
                    runStatus ?  console.log("locked") : toggleSidenav()
                }                 
            })
            gesture.enable();
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <Toolbar pageName="Home"/>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <IonModal isOpen={isLookingForOrder} id="transparent">
                <div className="modal-div">
                    <div id="modal">
                        <div className='loading-div'>
                          <div className="snippet" data-title=".dot-flashing" style={{ margin: "4px 16px"}}>
                            <div className="stage">
                              <div className="dot-flashing"></div>
                            </div> 
                          </div>
                        </div>
                    </div>
                </div>
            </IonModal>
            <IonToast
            isOpen={noOrderFound}
            color="white"
            message={`Hey there! We couldn't match this to any paychecks. ${orderPaidDate ? 'However, there is a record of payment for ' + orderPaidDate + '. Please try again at a later time.' : ''}`}
            duration={15000}
            cssClass="search-alert"
            onDidDismiss={()=>setNoOrderFound(false)}
            ></IonToast>
                    <div ref={ref} className="main" onClick={() => close()}>
                        <div>
                            <div>
                                <ProfileInfo/>
                                {/* <Game/> */}
                            </div>
                        </div>
                        <div>
                            {!UserUtils.isDriver() ? <Onboard/>:  null}
                            <Contacts/>
                            <IonItem lines="none" color="light">
                                <div className="item-container">
                                    <Link className='western-button-link' to="/registervehicle">
                                        <div className="space-between" style={{boxShadow: "0 4px 4px rgba(0,0,0,0.25)", background: "#34AAFF"}}>
                                            <p>Register personal vehicle</p>
                                            <img src={chevronRight} style={{ height: "1.8vh"}}alt="arrow"/>
                                        </div>
                                    </Link>
                                </div>
                            </IonItem>
                        </div>
                    </div>
                    
            </IonContent>
            <IonFooter>
                <Nav pageName="Home"/>
            </IonFooter>
    </IonPage>
    )

}

export default Home
